import { api } from "./http-client";

export interface PointTransaction {
  id: string;
  userId: string;
  amount: number;
  type: "EARN" | "SPEND";
  reason: string;
  referenceId: string | null;
  balanceAfter: number;
  topUpPackageId: string | null;
  topUpPoints: number | null;
  topUpBonusPoints: number | null;
  createdAt: string;
}

export interface PointHistoryResponse {
  balance: number;
  data: PointTransaction[];
  meta: { page: number; take: number; total: number; pageCount: number };
}

export const pointHistoryService = {
  getTransactions: (userId: string, page = 1, take = 20): Promise<PointHistoryResponse> =>
    api
      .request({
        method: "GET",
        url: `/admin/users/${userId}/point-transactions`,
        params: { page, take },
      })
      .then((r) => r.data),
};
